import { Navigator } from './integrationTypes'

let consoleFrontEndDomain = import.meta.env.VITE_CONSOLE_FRONTEND || "*";

export const BXP_CANVAS_BASE_URL = "/working-environments";
export const BXP_CANVAS_ADD_URL = "/add-working-environment";
export const BXP_FSX_STORAGE_CREATE_URL = "/fsxstorage/fsx/create";
export const SHELL_HOST_HEADER_HEIGHT = 72;
export const SHELL_HOST_LEFT_MENU_WIDTH = 228;

export const postReadyMassage = () => {
    if(import.meta.env.MODE === "development" || window.origin.includes("localhost")) {
        window.parent.postMessage({type: 'SERVICE:READY'}, "*");
    } else {
        window.parent.postMessage({type: 'SERVICE:READY'}, consoleFrontEndDomain);
        window.parent.postMessage({type: 'SERVICE:READY'}, import.meta.env.VITE_BLUEXP_FRONTEND);
    }

}

export const postMessageTarget = () => {
    if(import.meta.env.MODE === "development" || window.origin.includes("localhost")) {
        return "*"
    } else {
        return consoleFrontEndDomain;
    }
}

export const setConsoleFrontEndDomain = (url?: string) => {
    consoleFrontEndDomain = (!!url && url !== "*") ? url.startsWith("http") ? url : `https://${url}` : "*";
}

export const isInIframe = window.top !== window;

export const isInBlueXPIframe = ():boolean => {
    return import.meta.env.VITE_SOURCE === "console";
}

// occm's mfe/v2 contract never provides a callable `navigator` in
// initializationData (see useMfe.js) - it expects the mfe to ask its parent
// window to navigate instead. Use this as the fallback wherever a host may
// not supply its own `navigator`, matching wlmfsx's `parentNavigate`.
export const postMessageNavigate: Navigator = (payload) => {
    window.parent.postMessage({ type: 'SERVICE:NAVIGATE', payload }, postMessageTarget());
}
